import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
// import Loading from '../../components/layouts/Loading'
import { Container, Row, Col, Nav, InputGroup, FormControl, Button, Tab, Alert, Form } from 'react-bootstrap';
import PageHeader from "../../components/pageHeader/pageHeader.component";
import { FaSearch } from "react-icons/fa";

import BranchesPageCover from '../../assets/images/banners/branches-banner.png';

import './branches.module.css';
import BranchCard from '../../components/branchCard/branchCard';

const BranchesPage = props => {

    const { districts, branch } = useSelector(state => state.all)


    // const [selectedDistrict, setSelectedDistrict] = useState(null)
    // const [selectedBranches, setSelectedBranches] = useState([])
    // const [firstBranch, setFirstBranch] = useState('')

    // const [search, setSearch] = useState(null)

    // useEffect(() => {
    //     setFirstBranch(null)
    // }, [selectedBranches])

    // useEffect(() => {
    //     setFirstBranch(selectedBranches.length > 0 && selectedBranches[0].name)
    // }, [firstBranch])

    // useEffect(() => {
    //     let name = 'dhaka'
    //     let firstDistrict = branch.find(item => item.district === 'ঢাকা' || item.district.toLowerCase().includes(name.toLowerCase(name)))
    //     if (!firstDistrict) {
    //         firstDistrict = branch && branch[0]
    //     }
    //     firstDistrict = firstDistrict ? firstDistrict.district : ''
    //     setSelectedDistrict(firstDistrict)
    //     setSelectedBranches(branch.filter(item => item.district === firstDistrict))
    // }, [districts, branch])

    // const handleFilter = i => {
    //     setSelectedDistrict(i)
    //     setSelectedBranches(branch.filter(item => item.district === i))
    // }

    // const changeSearch = i => {
    //     setSearch(i)
    // }

    // const handleSearch = (e) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     setSearch(search)
    //     setSelectedBranches(branch.filter(item => item.name.toLowerCase().includes(search.toLowerCase())))
    // }

    // useEffect(() => {
    //     if (selectedBranches.length > 0) {
    //         setSelectedDistrict(selectedBranches[0].district)
    //     } else {
    //         setSelectedDistrict()
    //     }
    // }, [selectedBranches])

    // const selectBranch = e => {
    //     let selectedBranch = branch.find(item => item.name.includes(e.target.innerText))
    //     if (selectedBranch) {
    //         setSelectedDistrict(selectedBranch.district)
    //     }

    // }

    return (
        <div>
            <PageHeader title="আমাদের শাখাসমূহ" />

            {/* <section className="bracnh-district-section py-5 border-top border-bottom" styleName="bracnh-district-section">
                <Container>
                    <Row>
                        <Col>
                            <div className="mx-auto" styleName="branch-search-wrap">
                                <Form onSubmit={handleSearch}>
                                    <InputGroup className="mb-3">
                                        <FormControl
                                            onChange={(e) => changeSearch(e.target.value)}
                                            placeholder="শাখা খুজুন..."
                                            aria-label="শাখা খুজুন..."
                                        />
                                        <Button onClick={handleSearch} type="submit" variant="outline-secondary" styleName="search-btn">
                                            <FaSearch />
                                        </Button>
                                    </InputGroup>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col>
                            <div className="d-flex justify-content-center flex-wrap">
                                {districts && districts.map(item => {
                                    if (item === selectedDistrict) {
                                        return <Button className="btn-district active" styleName="btn-district" onClick={() => handleFilter(item)}>{item}</Button>
                                    } else {
                                        return <Button styleName="btn-district" onClick={() => handleFilter(item)}>{item}</Button>
                                    }
                                })}


                            </div>
                        </Col>
                    </Row>
                </Container>
            </section> */}

            <section className='py-5' styleName="branch-list-section">
                <Container>
                    <Row>
                        {
                            branch.map((item, index) => (
                                <Col className='mb-4' xs={12} md={4} key={`branch_${item._id}`}>
                                    <BranchCard branch={item} />
                                </Col>
                            ))
                        }
                    </Row>
                </Container>
            </section>

            {/* <section className="py-2 my-2 py-sm-5 my-sm-5" styleName="bracnh-list-section">
                {firstBranch ? <Tab.Container id="branch-map" defaultActiveKey={firstBranch}>
                    <Container>
                        <div className="m-3 m-sm-0" styleName="branch-map-wrap">
                            <Row className="mx-0">
                                <Col sm={{ span: 7, order: 'last' }} className="px-0" styleName="branch-map-column">
                                    <Tab.Content>
                                        {selectedBranches && selectedBranches.map(item => (
                                            <Tab.Pane eventKey={`${item.name}`} >
                                                <iframe
                                                    title={item.name}
                                                    styleName="branch-map-iframe"
                                                    src={item.mapUrl}
                                                    height="450"
                                                    allowfullscreen=""
                                                    loading="lazy"
                                                ></iframe>
                                            </Tab.Pane>
                                        ))}
                                    </Tab.Content>
                                </Col>
                                <Col sm={5} className="px-0" styleName="branch-map-nav-column">
                                    <Nav className="flex-column" >
                                        {selectedBranches && selectedBranches.length > 0 ? selectedBranches.map(item => (
                                            <Nav.Link defaultActiveKey={firstBranch} className="map-link" styleName="map-link" eventKey={`${item.name}`} onClick={e => selectBranch(e)}>
                                                <div className="d-flex flex-column">
                                                    <h5>{item.name}</h5>
                                                    <span styleName="address">
                                                        <strong>ঠিকানাঃ </strong>
                                                        {item.address}
                                                    </span>
                                                    <span styleName="mobile">
                                                        <strong>মোবাইলঃ </strong>
                                                        {item.phone}</span>
                                                </div>
                                            </Nav.Link>
                                        )) : <Alert variant="watning" className="text-center mb-0">
                                            দুঃখিত, এই নামে কোন শাখা খুজে পাওয়া যায় নি।
                                        </Alert>
                                        }

                                    </Nav>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </Tab.Container> : <Alert variant="watning" className="text-center mb-0">
                    দুঃখিত, এই নামে কোন শাখা খুজে পাওয়া যায় নি।
                </Alert>}
            </section> */}
        </div >
    )
}

export default BranchesPage;